module.exports = __webpack_public_path__ + "img/advice1.95a79e7a.png";